import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

export const canvasObjectUiEvents = eventGroup({
  source: 'Modeler Canvas Object UI',
  events: {
    fromRepoObjectAddedToCanvas: type<{
      interaction_type: 'drag' | 'click';
      location: 'toolbar' | 'canvas_quick_create';
      type?: string;
    }>(),
    draftObjectAddedToCanvas: type<{
      interaction_type: 'drag' | 'click';
      location: 'toolbar' | 'canvas_quick_create';
      metamodel?: string;
      shapeType?: string;
      promotionType?: string;
    }>(),
  },
});
